import Text from './Text'
export default Text
export type { ITextProps } from './Text.types'
